import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SYSTEMS } from "@/lib/constants";

const RELATED_MAP = {
  pvra: ["ar-ena", "pine-places"],
  "ar-ena": ["pvra", "pine-places"],
  "pine-vr": ["hotel-vr", "pine-places"],
  "hotel-vr": ["pine-vr", "pine-places"],
  "pine-places": ["hotel-vr", "pvra", "pine-vr"],
};

export default function RelatedSystems({ currentSlug }) {
  const slugs = RELATED_MAP[currentSlug] || [];
  const related = slugs
    .map((s) => SYSTEMS.find((x) => x.slug === s))
    .filter(Boolean);

  if (related.length === 0) return null;

  return (
    <section className="border-t border-[rgba(255,255,255,0.08)]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="overline mb-4">Verwandte Systeme</div>
        <h2 className="font-display text-2xl md:text-3xl uppercase leading-tight max-w-3xl">
          Wir empfehlen außerdem.
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px mt-10 border-l border-t border-[rgba(255,255,255,0.08)]">
          {related.map((s) => (
            <Link
              key={s.slug}
              to={s.path}
              className="border-r border-b border-[rgba(255,255,255,0.08)] p-6 md:p-7 hover:bg-[#0B0F10] transition-colors group"
              data-testid={`related-${s.slug}`}
            >
              <div className="font-display text-[#18E096] text-xs uppercase tracking-[0.2em]">
                {s.code} / SYSTEM
              </div>
              <h3 className="font-display text-xl md:text-2xl uppercase mt-3">{s.name}</h3>
              <div className="text-[#18E096] text-xs uppercase tracking-[0.2em] mt-1">
                {s.subtitle}
              </div>
              <p className="text-[#AEB7B7] text-sm mt-4 leading-relaxed">{s.short}</p>
              <div className="mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white group-hover:text-[#18E096] transition-colors">
                {s.cta} <ArrowUpRight size={14} strokeWidth={1.5} />
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/systeme" className="btn-secondary" data-testid="related-systeme">
            Alle Systeme
          </Link>
          <Link to="/ablauf" className="btn-secondary" data-testid="related-ablauf">
            Ablauf ansehen
          </Link>
          <Link to="/standort-pruefen" className="btn-secondary" data-testid="related-pruefen">
            Standortpotenzial prüfen
          </Link>
        </div>
      </div>
    </section>
  );
}
